module.exports = __webpack_public_path__ + "media/images/views/talent/benefit-people-8b46393a6bafe49a77fe5bb434ddf9ce.png";